// extracted by mini-css-extract-plugin
export default {"root":"root--AZBqX","rootIsDark":"rootIsDark--_1m8W","loader":"loader--_hoNj","message":"message--uqJbK","messageIsDark":"messageIsDark--HteXL"};